/* Claude 4.31 — collection toolbar behaviour.

   Four small jobs. Nothing here touches facets.js: the sort mirror drives
   Dawn's own #SortBy and lets Dawn do the section render.

   NO BACKSLASHES IN THIS FILE, anywhere. Uploading theme files through the
   GraphQL variable channel has silently doubled literal backslashes before
   (see the 4.08 record) — an invisible change that alters behaviour. Source
   with no backslash in it cannot be bitten. Character classes are spelled
   [0-9] rather than the shorthand escape for the same reason, and paths are
   trimmed with a loop instead of a regexp. */
(function () {
  if (window.cctInit) return;
  window.cctInit = true;

  function trimSlash(p) {
    var s = String(p || '');
    while (s.length > 1 && s.charAt(s.length - 1) === '/') {
      s = s.substring(0, s.length - 1);
    }
    return s.toLowerCase();
  }

  function pathOf(href) {
    try {
      return trimSlash(new URL(href, window.location.origin).pathname);
    } catch (e) {
      return '';
    }
  }

  /* 1. ACTIVE PILL. Ported from the script that used to live inside the
     Black Friday custom-liquid section, which is disabled as of 4.31. */
  function paintPills() {
    var here = trimSlash(window.location.pathname);
    var pills = document.querySelectorAll('[data-cct-pill]');
    Array.prototype.forEach.call(pills, function (a) {
      var p = pathOf(a.getAttribute('href'));
      if (!p) return;
      if (p === here) a.classList.add('cct__pill--active');
    });
  }

  /* 2. SCROLL POSITION ACROSS PILL NAVIGATION. A pill is a real page load,
     so without this the shopper is thrown back to the hero every time. */
  function wirePillScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-cct-pill]');
      if (!a) return;
      try {
        sessionStorage.setItem('cctY', String(window.scrollY || window.pageYOffset || 0));
      } catch (err) {}
    });
    try {
      var y = sessionStorage.getItem('cctY');
      if (y !== null) {
        sessionStorage.removeItem('cctY');
        window.scrollTo(0, parseInt(y, 10) || 0);
      }
    } catch (err) {}
  }

  /* 3. SORT MIRROR. The mobile chip sits outside every facet form on purpose,
     so it cannot be submitted twice. Setting #SortBy and dispatching 'input'
     is exactly what facets.js's facet-filters-form listens for, so filters and
     sort go to the server together. The reverse copy keeps the chip honest
     after Dawn re-renders the form from the server. */
  function wireSort() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;

      if (t.hasAttribute && t.hasAttribute('data-cct-sort')) {
        var real = document.getElementById('SortBy');
        if (!real) return;
        real.value = t.value;
        real.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }

      if (t.id === 'SortBy' || t.id === 'SortBy-mobile') {
        var chips = document.querySelectorAll('[data-cct-sort]');
        Array.prototype.forEach.call(chips, function (c) {
          if (c.value !== t.value) c.value = t.value;
        });
      }
    });
  }

  /* 3b. TAP THE DIM AREA TO CLOSE THE SHEET. claude-toolbar.css hides Dawn's X
     on mobile because Dawn parks it at the top of the viewport, nowhere near a
     bottom sheet -- but Dawn only closes its drawer from that X, the Apply
     buttons, or Escape; a tap on the backdrop does nothing. The backdrop is the
     .mobile-facets form itself (position:fixed, full viewport), so a click
     whose target IS that element is a tap outside the sheet. Clicking the
     summary is exactly what Dawn's own Apply button does, so the close runs
     through Dawn's animation and state, not around it. */
  function wireBackdropClose() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('mobile-facets')) return;
      if (!t.closest || !t.closest('.cct')) return;
      var d = t.closest('details');
      if (!d || !d.classList.contains('menu-opening')) return;
      var s = d.querySelector('summary');
      if (s) s.click();
    });
  }

  /* 4a. ACTIVE-FILTER BADGE. Liquid writes the count at render; facets.js
     replaces the active-facets lists on every filter change without a page
     load, so recount from the DOM whenever the facets container mutates. */
  function countActive() {
    var list = document.querySelector('.cct .active-facets-mobile');
    if (!list) list = document.querySelector('.cct .active-facets-desktop');
    if (!list) return 0;
    var n = list.querySelectorAll('facet-remove:not(.active-facets__button-wrapper)').length;
    return n;
  }

  function paintBadge() {
    var bar = document.querySelector('[data-cct]');
    if (!bar) return;
    var n = countActive();
    bar.setAttribute('data-cct-active', String(n));
    var open = bar.querySelector('.mobile-facets__open');
    if (open) open.setAttribute('data-cct-active', String(n));
  }

  function watchFacets() {
    var box = document.querySelector('.cct .facets-container');
    if (!box || typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function () {
      /* facets.js replaces the facet panels wholesale on every filter change,
         which takes the injected bands with them. Rebuild and re-read state. */
      injectBands();
      shortenFilterLabel();
      paintBadge();
    });
    mo.observe(box, { childList: true, subtree: true });
  }

  /* 4b. STICKY OFFSET. The header is sticky at z-index 4; park the bar
     directly under it rather than guessing a number. */
  function setTop() {
    var h = document.querySelector('.shopify-section-header, .section-header');
    var top = 0;
    if (h) {
      var pos = window.getComputedStyle(h).position;
      if (pos === 'sticky' || pos === 'fixed') top = h.getBoundingClientRect().height;
    }
    document.documentElement.style.setProperty('--cct-top', Math.round(top) + 'px');
  }

  /* 5. PRICE AS BANDS.
     Dawn renders price as two text fields (from / to). The bands replace the
     fields visually and write back into them, so nothing about Shopify's
     filtering changes -- the same filter.v.price.gte / lte pair is submitted,
     and dispatching 'input' on the field is exactly what facets.js listens for.

     WORTH KNOWING: Shopify supports ONE price window, not a set. Tick two
     bands with a gap between them (Under 200 and 400-plus) and everything in
     between comes with them, because the only thing that can be sent is the
     lowest floor and the highest ceiling. That is a platform limit, not a bug
     here. Bands are read from data-cct-price-bands on the bar, so changing
     them is a Liquid edit, not a JS one. */
  function bands() {
    var bar = document.querySelector('[data-cct]');
    var raw = bar && bar.getAttribute('data-cct-price-bands');
    if (!raw) return [];
    var out = [];
    raw.split(',').forEach(function (part) {
      var bits = String(part).trim().split('-');
      if (bits.length !== 2) return;
      var lo = bits[0] === '' ? 0 : parseInt(bits[0], 10);
      var hi = bits[1] === '' ? null : parseInt(bits[1], 10);
      if (isNaN(lo)) return;
      if (hi !== null && isNaN(hi)) return;
      out.push({ lo: lo, hi: hi });
    });
    return out;
  }

  function money(n) {
    return '£' + n;
  }

  function bandLabel(b) {
    if (b.lo === 0 && b.hi !== null) return 'Under ' + money(b.hi);
    if (b.hi === null) return money(b.lo) + ' and over';
    return money(b.lo) + ' to ' + money(b.hi);
  }

  function priceFields(panel) {
    var form = panel.closest('form');
    var scope = form || document;
    return {
      gte: scope.querySelector('input[name="filter.v.price.gte"]'),
      lte: scope.querySelector('input[name="filter.v.price.lte"]')
    };
  }

  function pushBands(panel) {
    var f = priceFields(panel);
    if (!f.gte || !f.lte) return;
    var boxes = panel.querySelectorAll('.cct-bands input');
    var lo = null;
    var hi = null;
    var openEnded = false;
    Array.prototype.forEach.call(boxes, function (b) {
      if (!b.checked) return;
      var bl = parseInt(b.getAttribute('data-lo'), 10);
      var bh = b.getAttribute('data-hi');
      if (lo === null || bl < lo) lo = bl;
      if (bh === '') {
        openEnded = true;
      } else {
        var n = parseInt(bh, 10);
        if (hi === null || n > hi) hi = n;
      }
    });
    f.gte.value = lo === null || lo === 0 ? '' : String(lo);
    f.lte.value = openEnded || hi === null ? '' : String(hi);
    f.gte.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function paintBandState(panel) {
    var f = priceFields(panel);
    if (!f.gte || !f.lte) return;
    var gte = f.gte.value === '' ? 0 : parseFloat(f.gte.value);
    var lte = f.lte.value === '' ? Infinity : parseFloat(f.lte.value);
    var boxes = panel.querySelectorAll('.cct-bands input');
    Array.prototype.forEach.call(boxes, function (b) {
      var bl = parseInt(b.getAttribute('data-lo'), 10);
      var bh = b.getAttribute('data-hi') === '' ? Infinity : parseInt(b.getAttribute('data-hi'), 10);
      b.checked = gte <= bl && lte >= bh;
    });
  }

  function injectBands() {
    var list = bands();
    if (!list.length) return;
    var panels = document.querySelectorAll('.cct .facets__display, .cct .mobile-facets__submenu');
    Array.prototype.forEach.call(panels, function (panel) {
      var range = panel.querySelector('price-range');
      if (!range) return;
      if (panel.querySelector('.cct-bands')) {
        paintBandState(panel);
        return;
      }
      range.classList.add('cct-hidden');
      var ul = document.createElement('ul');
      ul.className = 'cct-bands';
      list.forEach(function (b) {
        var li = document.createElement('li');
        var label = document.createElement('label');
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.setAttribute('data-lo', String(b.lo));
        input.setAttribute('data-hi', b.hi === null ? '' : String(b.hi));
        var span = document.createElement('span');
        span.textContent = bandLabel(b);
        label.appendChild(input);
        label.appendChild(span);
        li.appendChild(label);
        ul.appendChild(li);
      });
      range.parentNode.insertBefore(ul, range);
      ul.addEventListener('change', function () {
        pushBands(panel);
      });
      paintBandState(panel);
    });
  }

  /* 6. THE MOBILE BUTTON SAYS "Filter". Dawn's label is "Filter and sort",
     which at chip size is a mouthful and duplicates the Sort chip next to it.
     The sheet header keeps the full wording. */
  function shortenFilterLabel() {
    var labels = document.querySelectorAll('.cct .mobile-facets__open-label');
    Array.prototype.forEach.call(labels, function (l) {
      l.textContent = 'Filter';
    });
  }

  function init() {
    if (!document.querySelector('[data-cct]')) return;
    shortenFilterLabel();
    paintPills();
    wirePillScroll();
    wireSort();
    wireBackdropClose();
    injectBands();
    paintBadge();
    watchFacets();
    setTop();
    window.addEventListener('resize', setTop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
